export default {
  months: {
    jan: '一月',
    feb: '二月',
    mar: '三月',
    apr: '四月',
    may: '在五月',
    jun: '六月',
    jul: '在七月',
    aug: '八月',
    sep: '九月',
    oct: '十月',
    nov: '十一月',
    dec: '十二月',
  },
  all: '全部',
  day: '當日',
  one_month: '一個月',
  three_months: '三個月',
  six_months: '六個月',
  one_year: '一年',
  increase: '增加',
  deduction: '減少',
  memo: '留言',
  enter_memo: '請輸入留言.',
  price: '金額',
  new: '最新',
  past: '過去',
  enrollment: '登錄',
  re_enter: '重新輸入',
  registration_complete_txt: '登錄完成',
  registration_failed_txt: '登錄失敗',
  bank_name: '銀行名',
  locale_name: '中文(臺灣)',
  sale_registration: '出售登記',
  apply: '申請',
  status: '狀態',
  wallet: '錢包',
  buy: '購買',
  sell: '出售',
  breakdown: '記錄',
  act_buy: '購買',
  act_sell: '出售',
  asset: '資產',
  select: '選擇',
  no_select: '無選擇',
  account: '帳戶',
  balance: '平衡',
  login: '登錄',
  logout: '退出',
  register: '註冊',
  select_cancel: '取消選中',
  cancel: '取消',
  modify: '編輯',
  auto_input: '(自動輸入)',
  confirm: '確認',
  look_up: '查詢',
  password: '密码',
  account_delete: '註銷',
  detail: '詳細信息',
  list_detail: '詳細信息',
  birth: '生日',
  welcome: '歡迎',
  please_login: '請登錄',
  confirmation_login: '您可以在登錄時進行檢查。',
  id: 'ID',
  find_id: '查找ID',
  find_password: '查找密碼',
  back: '返回',
  agreement: '協議',
  info_input: '輸入信息',
  success: '完成',
  all_agree: '我同意所有',
  agree: '同意',
  confirm_password: '確認密碼',
  repeat_password: '確認密碼',
  next: '下一個',
  before: '回去',
  register_success: '您已註冊',
  verify: '確認',
  retention: '持有',
  allow: '(允許)',
  disallow: '(不允許)',
  upload_btn: '請在此處刪除或單擊文件。',
  continue_entry: '請在下面輸入“ [+:verification]”以繼續',
  login_msg_1: '請在ONEWORLDPAY<br>上使用COIN相關的賬號！',
  login_msg_2: '请通过我们ONEWORLDPAY交易并使用钱包和服务',
  login_msg_3: 'ONEWORLDPAY支持所有環境',
  cocofx_register: '註冊ONEWORLDPAY',
  register_msg_1: '加入作為會員。 <br />請同意我們的條款和條件',
  register_msg_3: '一個ONEWORLDPAY帳戶會給安心為大家服務的訪問。',
  register_msg_all:
    '所有人同意包括對必填項和可選項的同意，您可以單獨選擇同意。即使您拒絕同意這些選項，也可以使用該服務。',
  register_title: '我是19歲以上的年齡以上。',
  register_title_2: 'ONEWORLDPAY條款',
  register_title_3: 'ONEWORLDPAY集成服務條款',
  register_title_4: 'ONEWORLDPAY營銷槓桿同意',
  register_title_5: '同意收集和使用個人信息',
  register_title_6: '同意收集和使用位置信息',
  register_title_7: '同意收集其他個人資料信息',
  register_title_8: '輸入ONEWORLDPAY帳戶信息',
  register_title_9: '輸入信息',
  register_msg_4:
    '這些條款適用於公司提供的所有服務等。<br />接受這些條款，您可以使用這些服務而無需簽訂單獨的合同。',
  required: '[需要]',
  option: '[可選擇的]',
  otp_notice: '狀態被激活和停用OTP不可能的。',
  required_check: '請檢查所有必填字段',
  check_input: '請輸入所有的細節。',
  register_guide: '如何使用ONEWORLDPAY',
  register_step1: 'COCO點擊付款按鈕',
  register_step2: '登錄COCO收費',
  register_step3: '支付/充值COCO BANK登錄',
  copy: '複製',
  no_account: '沒有註冊的帳戶。',
  inviter_link: '推薦人鏈接',
  register_used_account: '註冊經常使用的賬戶',
  security_certification: '安全認證',
  company: '企業',
  exact_calculation: '調整',
  profile: '會員資料',
  inquiry: '查詢',
  inquiry_history: '聯繫方式',
  announcement: '通知',
  information: '信息',
  history: '歷史',
  registration_date: '登錄日',
  pay: '付款',
  detail_search: '詳細搜索',
  market: '市場',
  holding: '保持',
  fee_charged: '手續費附加額',
  type_of_charge: '手續費附加類型',
  auto: '自動的',
  manual: '手動的',
  s_usdt_protocol: '選擇泰德協議',
  header: {
    c2c_enroll: '購買/出售 登錄',
    wallet_list: '錢包/記錄查詢',
    wallet: '錢包',
    c2c_list: '購買/出售記錄',
    no_c2c_sell_list: '沒有銷售記錄。',
    transfer_list: '兌換記錄',
    no_transfer_list: '沒有兌換記錄',
    withdrawal_list: '存/取款記錄',
    my_info: '我的信息',
    home: '主要',
    payment_history: '帳單紀錄',
    account_transfer: '轉賬',
    transfer_history: '轉賬記錄',
    register_used_account: '註冊經常使用的賬戶',
    exchange: '為了交換',
    exchange_store: '交易所',
    exchange_list: '匯率查詢',
    email: '電子郵件',
    email_list: '電子郵件歷史記錄',
    otp: 'OTP',
    otp_list: 'OTP歷史',
    register_account: '註冊帳號',
    calculation_account_list: '結算清單',
    security_certification: '安全認證',
    exact_calculation: '調整',
    history: '歷史',
    coco_open_market: 'COCO公開市場',
    information: '信息',
    my_profile: '我的信息',
    email_modify: '編輯電子郵件',
    password_modify: '修改密碼',
    inquiry: '查詢',
    one_on_one_inquiry: '1:1 查詢',
    frequently_asked_questions: '常問問題',
    announcement: '通知',
    notice: '公告',
    server_notice: '伺服器公告',
    service_center: '服務中心',
    profile: '會員資料',
    company: '企業',
    account_management: '賬戶管理',
    do_exchange: '兌換',
    transfer: '轉讓',
    look_up: '參考',
    faq: '常問問題',
    server: '服務器',
    email_request: '電子郵件聯繫',
    Balance_transfer_history: '市場餘額移動記錄',
    no_balance_transfer_history: '沒有市場平衡運動的歷史。',
    manual: '手册',
  },
  header_sub: {
    exchange_list: '兌換記錄',
    transfer_list: '轉賬記錄',
  },
  footer: {
    footer_msg: '請在ONEWORLDPAY上使用COIN相關的賬號！',
    footer_sub_msg: '請通過我們的ONEWORLDPAY使用交易，錢包和服務',
    footer_sub_msg2: '提示',
    footer_sub_msg3: 'ONEWORLDPAY支持所有環境',
    ICO: 'ICO',
    c2c: 'C2C交易所',
    b2c: 'B2C交易所',
    margin_exchange: '保證金交易所',
    futures_exchange: '期貨交易所',
    Binary: '二元期權',
    open_marcket: '公開市場',
    game: '遊戲',
    proceed: '正在進行的交易',
    public: '已列出',
    direct_ex: '直接兌換',
    buy: '購買',
    sell: '出售',
    buy_sell: '买/卖',
    holding_coin: '持有硬幣',
    fee: '費用信息',
    exchange: '交流',
    transfer_record: '交易記錄',
    Leverage: '槓桿',
    live_exchange: '實時交易',
    demo_exchange: '模擬交易',
    contest: '競賽',
    powerball: '強力球',
    law:
      '法律：ONEWORLDPAY.COM 登錄號碼：70638826927（U 6 29 Railway Pde EastwoodNSW 2122）',
    law1:
      'Trading Point of Financial Instruments Ltd（澳大利亞）的全部所有者ONEWORLDPAY PTY Ltd登錄號碼：70638826927商號。',
    law2:
      '該網站由ONEWORLDPAY Corp運營。ONEWORLDPAY Corp的批准號碼為64190-由Auxiliary finance service制約，參考號碼為70638826927在澳大利亞登錄。',
    law3: 'ONEWORLDPAY是根據澳大利亞金融商品投資方針運營的。',
    law4:
      'ref. no. 538324 | ABN reg. 70638826927 | BA reg. 64190. 在居住國家的法律規定中，確認ONEWORLDPAY服務是否允許使用是顧客的責任。',
    law5: '請閱讀ONEWORLDPAY的危險公示專文。',
    law6:
      'ONEWORLDPAY不為美國、貝里斯、模里西斯、日本、阿爾伯塔、英屬哥倫比亞、魁北克、薩斯喀徹、海地、蘇利南、北韓、波多黎各和塞普勒斯佔領地區的居民提供服務。',
    law7: '詳細內容請參考常問問題制約部分。請參考我們的風險公示',
    law8:
      '限制地區：Trading Point of Financial Instruments Ltd不向第三世界國家地區提供投資和附加服務。',
    law_warn: '風險提示:',
    law_1:
      'CFD具有高風險和複雜的產品，由於槓桿作用會有很大的風險。個人投資者69.10％中CFD交易時，都會虧錢。',
    law_2:
      '您必須考慮是否能接受和理解CFD的運行方式，擁有較高賠錢的風險。請參考我們的風險公示。',
    alert_title: '注注和',
    coco_market: 'COCO市場',
    ieo_market: 'IEO市場',
    news: '新聞',
    event: '活动',
    platform_rental_title: '平台出租',
    education: '教育',
    online_Academy: '線上學院',
    offline_Academy: '線下學院',
    shopping_basket: '購物車',
    best_product: 'best 商品',
    order: '訂購',
    my_page_title: '我的頁面',
    member_info_management: '會員信息管理',
    order_management: '訂單管理',
    my_question: '我的問題',
    one_enquiry: '1：1諮詢',
    community: '社區',
    lotto: '樂透型彩票',
    rock_event: '剪刀石頭布',
    quiz_game: '答題遊戲',
    ladder_game: '梯子遊戲',
    tetris: '俄羅斯方塊',
    split_lotto: '分享彩票',
    day_Lottery: '一日彩票',
    attendance: '簽到',
    scoop_out: '轉發',
    forum: '論壇',
  },
  b2c_exchange: {
    trading_view: 'TradingView',
    basic_chart: '基本圖表',
    today_hight: '高價（同一天）',
    today_row: '低價（同一天）',
    tightening_strength: '緊固強度',
    h24_volume: '交易量（24H）',
    h24_transaction_amount: '交易金額（24H）',
    previous_days_closing_price: '前一天的收盤價',
    auxiliary_indicator: '輔助指標',
    unlimited_number: '您可以選擇不限數量的指標。 ',
    rod_type: '桿型',
    chart_type: '圖表類型',
    market_name: '市場名',
    present_price: '現價',
    compared_to_the_previous_day: '前日對比',
    volume: '交易量',
    coin_name_and_symbol_search: '幣名/搜索',
    event: '種類',
    asking_price_window: '叫價窗',
    sell_order: '賣出',
    buying_order: '買入',
    limits: '指定價',
    maximum_order_price_quantity: '最大訂購價格數量',
    direct_input: '直接輸入',
    order_classification: '訂單分類',
    order_available: '可訂購',
    order_quantity: '訂單數量',
    total_order_amount: '訂單總額',
    quantity_user_fee_rate: '數量使用者手續費率',
    quantity_creator_fee_rate: '數量組織者手續費率',
    reset: '初始化',
    conclusion_price: '成交量',
    tightening_amount: '成交量',
    execution_time: '成交時間',
    execution_price: '成交價格',
    execution_quantity: '成交數量',
    execution_amount: '成交金額',
    order_date_and_time: '訂單日期和時間',
    transaction_coin: '交易幣',
    order_price: '訂單價格',
    untraded_quantity: '未成交數量',
    state: '州',
    current_price: '現價',
    division: '區分',
    transaction_price: '成交價',
    week52_high: '最多52週',
    week52_minimum: '52周最低',
    days_closing_price: '前一天的收盤價',
    same_day_high_price: '當日最高價',
    low_price_on_the_day: '當日最低價',
    average_price: '平均價格',
    cumulative_quantity: '累計數量',
    cumulative_amount: '累計量',
    selection: 'Selection',
    minimum_ask_quantity: '最高要價',
    save: '救',
    accounts_that_can_be_traded: '沒有可用的交易賬戶。',
    won_pay: '韓元',
    coin_order: '訂購',
    asking_price: '詢問價格',
    chart: '圖表',
    quote: '引用',
    order_details: '訂單詳細信息',
    account_number: '帳號',
    moving_quantity: '移動數量',
    registration_date: '登记日期',
  },
  main_msg: {
    about_1_title: '世界上最好的加密貨幣交易服務',
    about_1_msg: 'ONEWORLDPAY引領有關COIN的所有服務',
    about_1_1_msg: '世界首家最齊全的買賣加密貨幣市場',
    about_1_2_msg: '可以在ONEWORLDPAY體用直接兌換',
    about_2_title: '立即兌換系統',
    about_2_msg:
      'ONEWORLDPAY使用穩定的多重並行匹配技術 先進的設計技術可實現即時交換 我有貨幣兌換系統',
    about_3_title: '創建錢包',
    about_3_msg:
      'ONEWORLDPAY由國內最強的技術團隊組成，安全專家具備最尖端的安全系統，提供Wallet系統。',
    about_4_title: '簡易交易系統 （C2C）',
    about_4_msg:
      'ONEWORLDPAY建立了用戶更人性化的便捷交易系統，使交易更加方便。',
    c2c_main_msg1_1: 'ONEWORLDPAY擁有一個穩定的多重平行匹配技術，',
    c2c_main_msg1_2: '可以立即兌換的高度化設計技術的兌換系統。',
    c2c_main_msg1_3: '',
    c2c_main_msg2_1: '安全專家已經ONEWORLDPAY是由韓國最好的工程師',
    c2c_main_msg2_2: '配備了國家的最先進的安全系統提供電子錢包系統。',
    c2c_main_msg3_1: 'ONEWORLDPAY更容易建立人性化的交易系統',
    c2c_main_msg3_2: '它可以很容易地交易。',
  },
  toasted_msg: {
    confirm: '已確認',
    changed: '更改',
    withdrawal: '已停用',
    register: '已登錄',
    delete: '它已被刪除。',
    title: '通知',
    exchange: '直接貨幣已成功處理。',
    search: '已查看',
    deposit_request: '您的存款請求',
    withdraw_request: '要求提款',
    create_account: '賬戶專號',
    modify: '修改',
    cancel: '取消',
    trade_confirm: '交易已確認。',
    trade_reject: '交易被拒絕。',
    copy: '已復制',
    nice_msg: '如果您的瀏覽器設置不允許彈出窗口，則身份驗證將無法正常進行。',
    nice_title: '指南',
    nice_success: '您的認證成功。',
    nice_error: '我無法驗證自己的身份。',
    no_transfer: '沒有交換信息',
    email_auth: '電子郵件驗證成功完成',
    email_auth_send: '驗證電子郵件已發送',
    kyc_withdraw: '帳戶驗證成功',
    not_allow_trade: '交易無效',
    id_find_mail_send: '您的電子郵件已發送。',
    duplicate_check: '重複的ID或郵件。',
    pay: '付款完畢。',
    msg_holding: '保持',
    msg_read_care: '您確認注意事項了嗎？',
    answer_care: '是，我已確認',
    continuation: '繼續',
    continue_entry: '如果要繼續的話，請在下面輸入“[+:verification]”。',
  },
  private: {
    market_name: '市場名',
    deal_list: '出售記錄',
    app_list: '購買記錄',
    app_detail: '詳細購買記錄',
    deal_buy_asset: '要購買的資產',
    buy_price: '購買價格ㄴ',
    confirmed_source_amount: '確定出售數量',
    holding_source_amount: '未確定出售數量',
    potential_source_amount: '數量',
    direct_market: '直接兌換',
    deal_enroll: '出售登記',
    app_enroll: '購買登記',
    select_market: '請選擇市場',
    fee_rate: '手續費',
    free: '免費',
    deal_info_input: '請輸入出售信息',
    deal_source_amount: '出售數量',
    deal_price: '單價',
    deal_enroll_account: '出售登記用賬號',
    account_select: '選擇帳戶',
    direct_asset_select: '請選擇要出售和購買的資產',
    please_select_asset: '請選擇資產',
    basic_rate: '當前價格',
    direct_transfer_buy: '立即購買',
    direct_transfer_sell: '立即出售',
    direct_source_amount: '交換數量',
    direct_target_amount: '應用數量',
    direct_asset_buy: '用{0}進行購買',
    direct_asset_sell: '作為{0}出售',
    selected_deal_info: '所選擇的出售信息',
    deal_source_asset_title: '購買資產',
    deal_total_source_amount: '總出售量',
    app_info_input: '輸入購買信息',
    app_amount: '購買數量',
    app_deal_price: '單價',
    pay_target_amount: '付款數量',
    fee: '手續費',
    fee_calc: '手續費金額',
    msg_fee_calc: '減少{0}左右。',
    app_account: '購買登記用賬戶',
    app_receive_account: '選擇要接收的帳戶',
    c2c_buy_select_asset: '請在主頁上選擇要購買的出售公示',
    go_home: '回到主頁',
    buy_calc_spread: '購買匯率',
    sell_calc_spread: '賣出價',
    cs_market_asset: '資產對',
    cs_market_basic_rate: '基線銷售率',
    transfer_type: '貨幣類型',
    exchange_rate: '適用匯率',
    submit_transfer: '立即交換',
    deal_source_min_amount: '最少購買數量',
    closed_date: '終結日',
    no_deal: '無銷售清單',
    app_price_per_quantity: '單價',
    app_fee_amount: '手續費 合計',
    select_deal_app_list: '所選擇的購買記錄',
    no_select_deal_app_list: '此交易沒有購買記錄ㄴ',
    transfer_source_amount: '基準資產數量',
    transfer_target_amount: '相對資產數量',
    transfer_basic_rate: '應用買賣基准率',
    transfer_spread_rate: '應用點差率',
    transfer_exchange_rate: '應用匯率',
    transfer_list_detail: '詳細兌換申請記錄',
    transfer_source_asset: '基準資產',
    transfer_target_asset: '相對資產',
    transfer_source_account_number: '基準資產賬號',
    transfer_target_account_number: '相對資產帳號',
    transfer_detail_type: '交換類型',
    transfer_regdate: '申請日期',
    transfer_asset_info: '{0}至{1} {2}',
    transfer_asset_select: '請選擇要替換的資產。',
    msg_transfer_buy: '用{0}進行購買',
    msg_transfer_sell: '以{0}出售',
    deal_fee_amount: '賣出公示者 附加手續費',
  },
  wallet_page: {
    total_amount: '總支出額',
    have_asset: '持有資產',
    asset_list: '資產列表',
    account_list: '帳戶列表',
    account_create: '創建賬戶',
    deposit: '存款',
    withdraw: '凍結金額',
    deposit_list_look: '開戶前',
    deposit_look: '存款查詢',
    withdraw_list_look: '創建',
    withdraw_look: '提款查詢',
    account_modify: '編輯帳戶',
    deposit_apply: '申請存款',
    withdraw_apply: '取款',
    deposit_request_amount: '存款金額',
    withdraw_request_amount: '取款金額',
    withdraw_account_info: '提款帳戶信息',
    holder_name: '持有人的姓名',
    bank_name: '銀行名稱',
    withdraw_bank_address: '帳號',
    withdraw_address: '資產地址',
    qr_address: '帳戶地址',
    create_qr_address: '開設帳戶地址',
    account_enroll: '帳戶註冊',
    account_title: '帳戶名',
    account_msg: '請輸入要變更的賬戶名',
    regdate: '開戶日期',
    before_regdate: '(開戶前)',
    holding_balance: '凍結金額',
    select_asset: '選擇資產',
    create: '創建',
    deposit_list: '存款記錄',
    no_deposit_list: '沒有存款申請的詳細信息。',
    deposit_apply_detail: '詳細存款申請記錄',
    asset_title: '資產名稱',
    request_amount: '請求金額',
    withdraw_list: '取款記錄',
    no_withdraw_list: '沒有取款申請記錄',
    withdraw_apply_detail: '詳細取款申請記錄',
    withdraw_fee_total_amount: '總取款額（包含手續費）',
    net_amount: '最終金額',
    fee_type: '手續費類型',
    create_account_address: '開戶地址',
    deposit_msg: '從錢包外面存入我的錢包{0} {0}。',
    deposit_msg_1: '一旦被批准350倍（確認）的嵌段鏈{0}的交易將反映在錢包。',
    deposit_step_1: '步驟1首先檢查ID {0}備忘錄。',
    deposit_step_1_1: '我的筆記ID {0}',
    deposit_step_1_2:
      '{0}當你的存款必須標記你自己的筆記ID。 {0}，沒有轉印筆記ID丟失。',
    deposit_step_1_3: '查看您的{0}錢包地址。',
    deposit_step_1_btn: '注身份證複印',
    deposit_step_2: '第2步：檢查你的錢包地址。',
    deposit_step_2_1: 'QR碼',
    deposit_step_2_2: '錢包地址',
    deposit_step_2_3:
      '最低存款量的<span style =“顏色：＃4a90e2”> {0} {1} </跨度>。',
    deposit_step_2_btn: '錢包複製地址',
    deposit_msg_2: '請檢查',
    deposit_msg_2_1: '這個地址都是只存。',
    deposit_msg_2_2:
      '它需要以符合完成的總時間可通過塊鏈網絡的擁塞的影響，cryptocurrency星塊鏈接擁塞的<span style ="color: #4a90e2; cursor: pointer;">此處</span>你可以檢查。',
    no_account_list: '沒有帳戶列表。',
    no_favorite_account_list: '沒有收藏夾帳戶列表。',
    enter_wallet_adress: '輸入錢包地址',
  },
  my_page: {
    my_profile: '我的信息',
    user_name: '用戶名',
    email_address: '電子郵件',
    register_regdate: '註冊日期',
    last_login: '上次登錄',
    auth_complete: '身份驗證完成',
    not_auth: '未認證',
    expdate: '到期日',
    act_auth: '認證',
    realname_auth: '人員身份驗證',
    email_auth: '電子郵件認證',
    otp_auth: 'OTP 認證',
    enroll: '登錄',
    security: '安全級別',
    show_security: '查看安全等級',
    auth_withdraw_address: '取款地址驗證',
    apply_list: '申請記錄',
    password_modify: '修改密碼',
    email_modify: '修改電子郵件',
    account_block: '註銷',
    placeholder_old_password: '請輸入您的現有密碼',
    placeholder_new_password: '請輸入新密碼',
    placeholder_confirm: '請再輸入一次',
    placeholder_password: '請輸入密碼',
    placeholder_email: '請輸入新的電子郵件',
    mail_cert_list: '電子郵件應用歷史',
    no_mail_list: '沒有電子郵件應用歷史。',
  },
  kyc: {
    str_birth: '出生年月日',
    enter_adress: '請輸入資產地址',
    register_account: '註冊帳號',
    kyc_enroll: '申請KYC認證',
    auth: '身份驗證',
    auth_code_send: '發送驗證碼',
    auth_code: '驗證碼',
    msg_auth_code: '請在5分鐘內輸入您的驗證碼',
    type_title: '類型名稱',
    withdraw_auth: '取款地址驗證',
    select_asset: '選擇資產',
    select_bank: '選擇銀行',
    holder_name: '儲戶名',
    birth: '出生的6位數字',
    address: '資產地址',
    withdraw_list: '取款賬戶申請記錄',
    bank_name: '銀行',
    withdraw_info: '取款賬戶信息',
    withdraw_complete: '資產已被驗證。',
    regdate: '註冊日期',
    delete_withdraw_address: '取款地址變更',
    delete_success_address: '撤出地址已更改。',
    kyc_cert_list: 'KYC申請記錄',
    no_kyc_list: 'KYC是沒有應用歷史。',
    no_kyc_withdraw_address_list: '沒有支付賬戶的應用歷史。',
  },
  otp: {
    enter_verification_number: '輸入您的OTP驗證碼',
    otp_auth: 'OTP認證',
    authenticode: 'OTP密鑰',
    otp_deactivate: '停用OTP',
    msg_authenticator_installation:
      '請在智能手機或台式機上安裝“ Google Authenticator”應用',
    android: 'android ',
    or: '或 ',
    iphone_series: 'iPhone，iPad和iPod',
    windows_phone: ' Windows Phone',
    and: ', 和',
    msg_microsoft_other_systems: '其他系統，包括Microsoft Windows桌面',
    msg_key: '此密鑰',
    msg_use_loss_change: ' 寫在紙上當您丟失設備或需要更改OTP時使用。',
    msg_brcode_touch:
      '運行“ Google Authenticator”應用，然後點擊屏幕底部的<b>掃描QR條形碼</ b>。',
    msg_input_authenticode:
      '請在“身份驗證代碼”下面的字段中輸入顯示在終端屏幕上的驗證碼。',
    otp_key: 'OTP密鑰',
    otp_activate: 'OTP激活',
    otp_copy: '已復制OTP密鑰',
    otp_safe_keeping: '您是否將OTP密鑰寫在紙上並將其存儲在安全的地方？',
    yes: '是',
    otp_register: '註冊',
    otp_register_success: 'OTP註冊成功完成',
    otp_delete_success: 'OTP擦除註冊成功完成。',
    msg_click_key_copy: '單擊以復制密鑰',
    otp_login: 'OTP登錄',
  },
  security: {
    show_security: '顯示安全級別',
    grade: '等級',
    condition: '條件',
    restriction: '限制',
    no_grade: '未分級',
    no: '無',
    security_title: '受安全條件的約束',
    banner1: '可靠的安全性',
    banner2:
      '對於通過ONEWORLDPAY購買或出售，ONEWORLDPAY必須通過安全的結算和付款方案對接收ONEWORLDPAY安全數據加密，實時交易監控，買方和賣方保護政策，以及所有的付款。',
    banner_invite: 'ONEWORLDPAY還沒有賬號？',
    banner_join: '免費會員註冊',
    banner3: '如何ONEWORLDPAY是保持我們的客戶的安全',
    content1_h3: '買家保護',
    content1_text:
      '如果買方ohbaesong磨損或損壞mibaesong，ONEWORLDPAY可以彌補總付款金額，包括運費為符合條件的交易成本。*',
    content2_h3: '賣家保護',
    content2_text:
      '如果你收到一個未經授權的付款或mibaesong要求對賣方在銷售符合條件，就可以得到全額保護。*',
    content3_h3: '數據加密',
    content3_text:
      '以幫助TLS，HTTPS連接保持支付，關鍵釘扎移動應用的，符合PCI標準更安全。',
    content3_btn: 'PCI法規遵從',
    content4_h3: '防欺詐',
    content4_text:
      '所有的交易都是通過分析您的帳戶和支持，以防止欺詐行為和結算實時監控。',
    sec_h2: '檢查購買',
    sec_text:
      'ONEWORLDPAY因為監控每天24小時，一年365天，當它檢測到來自平常不同的東西聯繫買家交易要求您確認您的登錄或購買。此外ONEWORLDPAY檢查通過e-mail所有的採購和銷售。',
    wran_h2: '如果你發現一個可疑點',
    warn_step1: '報告。',
    warn_step1_text1: '確認之後的細節還沒有找到一個交易批准',
    warn_step1_text2: '報告問題>未經授權的活動報告',
    warn_step1_text3: '點擊或立即聯繫ONEWORLDPAY。',
    warn_step2: '檢查是否有其他問題。',
    warn_step2_text1:
      '查看近期交易活動和帳戶設置，以確保該額外費用或變更，也請將此信息報告。',
    warn_step3: '請更改您的密碼。',
    warn_step3_text1:
      '你可以在安全菜單上的帳戶設置。或者，如果您無法在您的帳戶登錄',
    warn_step3_text2: '登錄>登錄問題',
    warn_step3_text3: '點擊獲取復位。',
    warn_btn: '報告未經授權的交易',
    online_h2: 'ONEWORLDPAY支持安全的網上活動。',
    online_h3: '帳戶安全',
    online_text: '具有高度安全的密碼保護您的帳戶。',
    online_btn: '了解更多',
  },
  input: {
    id: '輸入ID',
    password: '輸入密碼（8-32位數字與特殊字符）',
    repeat_password: '確認密碼',
    user_name: '輸入用戶名',
    email_address: '輸入E-mail地址',
  },
  oauth: {
    contact_msg: '想要訪問應用程序中的{0}的以下信息。',
    agree_msg: '{0}你是否同意訪問{1}的個人信息？',
    agree_info:
      '/儲存一段服務的用戶標識提供將被使用的信息，統計，帳戶鏈接的CS等。基本信息並提供所需的項目是必須提供使用ONEWORLDPAY服務的信息。',
    agree_request: '供品',
    agree_msg2:
      '一旦同意，這些信息將按照條款和條件以及服務的隱私政策進行管理。',
    agree: '同意',
  },
  pay_head_foot: {
    account_management: '賬戶管理',
    settlement_account_list: '結算賬戶清單',
    account_summary_views: '帳戶摘要視圖',
    fund: '資金',
    history: '帳單紀錄',
    help: '幫助',
    qa: '諮詢',
    fee: '佣金',
    secure: '安全',
    go_shop: '購物',
    my_info: '我的個人資料',
    my_page: '帳戶設置',
    out: '退出',
    in: '登錄',
    about: '公司介紹',
    blog: '博客',
    employ: '喬布斯',
    site_map: '網站地圖',
    developer: '開發人員',
    partner: '夥伴',
    privacy_state: '隱私政策',
    usage: '使用條款',
    feed_back: '反饋',
    warn_to_consumer:
      '通知客戶：支付ONEWORLDPAYⓒONEWORLDPAY All rights reserved的預付費方式的業主不需要澳大利亞金融監管局的批准。請仔細閱讀條款和條件。',
  },
  continue: '延續',
  pay_home: {
    cocobank_title: 'COCO銀行',
    platform: '平台',
    platform_rental: '租賃平台',
    cocopay_is: 'ONEWORLDPAY是業務的增長',
    help: '幫助。',
    home_banner_1: '擴大潛在客戶群遍及世界各地，並促進支付管理，',
    home_banner_2: '經營的賣家保護*，並允許安全與全天候防欺詐監控到店。',
    home_banner_3: '你可以更容易獲得成功。',
    home_banner_warn: '*條款和條件適用於保護賣家。請參閱您的合同上的資格詳情。',
    home_banner_join: '現在加入免費。',
    home_sec1_openShop: '您可以在ONEWORLDPAY開一家店。',
    home_sec1_btn: '為了應對',
    home_sec2_h2: '獲取所需的付款方式。',
    home_sec2_text1: 'ONEWORLDPAY還可以接收在線付款，手機，甚至是電子郵件。',
    home_sec2_text2:
      '無論ONEWORLDPAY出售任何地方誰可以更方便，更安全的支付協助。',
    home_sec2_online_pay: '在線支付',
    home_sec2_online_text:
      '便於組可用ONEWORLDPAY付款按鈕接受現金支付和定期支付，捐贈等時非常方便隨著ONEWORLDPAY結帳，客戶可以進行支付更加方便快捷。',
    home_sec2_online_more: '查看更多有關網上支付',
    home_sec2_voice_invoice: '電子郵件發票',
    home_sec2_voice_text:
      '對於支付給專業的免費發票簡易電子郵件請求。海外客戶以及可供誰不ONEWORLDPAY帳戶的客戶。',
    home_sec2_voice_more: '查看更多有關電子郵件發票',
    home_sec2_exchange_pay: '在交易所付款',
    home_sec2_exchange_text:
      '借助交易所上集成的錢包服務，您可以在合作夥伴公司的任何交易所進行充值和買賣硬幣。',
    home_sec2_exchange_more: '了解有關交易所收費的更多信息',
    home_sec2_mobile_pay: '獲取移動支付',
    home_sec2_mobile_text:
      '解決方案是針對移動設備自動優化。獲得世界裡，甚至通過移動網站或Android和iOS應用更容易支付。',
    home_sec2_mobile_more: '查看更多關於移動支付',
    home_sec3_h2: '找到ONEWORLDPAY特約合作夥伴更多的工作。',
    home_sec3_global:
      'ONEWORLDPAY將與世界頂級自由職業者的網站連接更多的全球機會。',
    home_sec3_btn: '檢查自由ONEWORLDPAY',
    home_sec4_h2: '這很容易上手。',
    home_sec4_banner1: '了解你需要從ONEWORLDPAY商業中心開始一切。',
    home_sec4_banner2: '加盟商的帳戶，並確認您的電子郵件地址',
    home_sec4_banner3: '認證的銀行賬戶',
    home_sec4_banner4: '選擇一個支付解決方案',
    home_sec5_h2: '為什麼世界上許多運營商做的信任ONEWORLDPAY。',
    home_sec5_sub_text:
      '因為它是一個很好的選擇。 ONEWORLDPAY是否想與25個電話賣家至少兩個億人連接到客戶在超過200個全球市場。',
    home_sec5_h3: '安全。',
    home_sec5_h3_sub1:
      '自動確定騙局，24小時監控交易和買賣雙方的保護程序，以保護您的業務和客戶。',
    home_sec5_h3_more: '查看更多有關網上支付',
    home_sec5_h31: '全世界都在使用。',
    home_sec5_h31_sub1:
      '在世界各地，而無需輸入信息每次付款迅速的時間。在26貨幣市場的203，你可以通過信用卡，借記卡或支付ONEWORLDPAY。',
    home_sec5_h31_more: '查看更多有關電子郵件發票',
    home_sec5_h32: '快。',
    home_sec5_h32_sub1:
      '在大多數情況下，當客戶支付會立即存入您的帳戶ONEWORLDPAY。扣除銀行或在任何地方ONEWORLDPAY付款可以支付給供應商或自由使用。',
    home_sec5_h32_more: '查看更多有關eBay網站上出售',
    home_sec6_h2: '簡單的收費結構',
    home_sec6_sub:
      'ONEWORLDPAY會收取一定的費用，只有當銷售取得。 ONEWORLDPAY費用是根據客戶的位置和銷售金額固定。',
    home_sec6_more: '查看更多有關費用',
    home_sec7_h2: '社區為韓國銷售，CBT LAB',
    home_sec7_text1:
      '跨境貿易研究所（CBT LAB）是資助海外的電子商務ONEWORLDPAY韓國（ONEWORLDPAY韓國）商人社區啟用。',
    home_sec7_text2:
      'CBT LAB幫助東海岸業務增長全球共享信息，如最新趨勢，提示和最佳實踐。',
    home_sec7_more: '了解如何採取CBT LAB的優勢',
    home_sec8_h2: '滿足合作夥伴聯鎖ONEWORLDPAY。',
    home_sec8_text1: '需要為您的網上業務的專業幫助？',
    home_sec8_text2:
      'Web託管解決方案，購物車，電子商務解決方案，如前期工程ONEWORLDPAY合夥買了這幫助您的業務。',
    home_sec8_text3: '現在發現ONEWORLDPAY為自己的公司的合作夥伴。',
    home_sec8_more: '更多的合作夥伴',
    home_sec9_h2: '成為全球暢銷書。這將一起ONEWORLDPAY。',
    home_sec9_btn: '立即註冊一個帳戶',
    home_learn_h2: '了解更多',
    home_learn_li1: '網絡支付解決方案',
    home_learn_li1_1: '網站付款標準',
    home_learn_li1_2: 'ONEWORLDPAY結帳',
    home_learn_li1_3: '在eBay上購買',
    home_learn_li1_4: '比較解決方案',
    home_learn_li2: '其他應付款',
    home_learn_li2_1: 'ONEWORLDPAY電子郵件發票',
    home_learn_li2_2: '移動商務',
    home_learn_li2_3: '業務的自動付款',
    home_learn_li2_4: 'ONEWORLDPAY對於B2B',
    home_learn_li2_5: 'ONEWORLDPAY自由職業者',
    home_learn_li3: 'ONEWORLDPAY設置和集成',
    home_learn_li3_1: 'ONEWORLDPAY商業中心',
    home_learn_li3_2: 'ONEWORLDPAY韓國商人社區（CBT LAB）',
    home_learn_li3_3: '添加ONEWORLDPAY ONEWORLDPAY到現場',
    home_learn_li3_4: '檢查出最好的指南套裝',
    home_learn_li3_5: '開發人員',
    home_learn_li3_6: '夥伴',
    home_learn_li3_7: '如何ONEWORLDPAY',
    home_learn_li4: '管理我的帳戶',
    home_learn_li4_1: 'ONEWORLDPAY商業應用',
    home_learn_li4_2: '商務帳戶設置',
    home_learn_li4_3: '賣家保護計劃',
    home_learn_li4_4: '管理客戶投訴',
    home_learn_li4_5: '了解退款（退款）',
    home_learn_li4_6: '了解帳戶限制',
    home_learn_li4_7: '詐騙防範技巧',
    home_learn_li4_8: 'PCI法規遵從',
  },
  pay_nav: {
    view_your_account: '查看您的整個帳戶',
    account_summary_views: '帳戶摘要視圖',
  },
  pay_login: {
    secure_sub_title: '登錄和安全性',
    secure_my_profile: '我的個人資料',
    secure_update_complete: '環境狀況和設置已經更新。',
    secrue_suggest: '每當你告訴我們你的經驗。',
    search: '取回',
    my_info: '個人信息',
    update: '更新',
    e_mail: '電子郵件',
    default: '基本信息',
    call: '電話',
    phone: '（手機）',
    pay_mobile: '移動支付',
    trading: '給予和索取',
    password: '密碼',
    change: '變化',
    secure_qa: '安全問題',
    staying: '記住我的登錄更快採購',
    edit: '彙編',
    browse_manage: '管理所選設備和對保持登錄狀態的瀏覽器。',
    account_type: '賬戶類型',
    account_delete: '帳戶取消',
    business: '業務',
    edit_email: '編輯電子郵件地址',
    change_email: '更改電子郵件地址',
    update_email: '添加您的電子郵件',
    eamil_url: 'E-mail地址',
    update_email_url: '添加您的電子郵件地址',
    error_email: '抱歉。默認的電子郵件不能被編輯。',
    confirm_new_email: '檢查新的電子郵件地址',
    change_mail: '更改電子郵件',
    confirm: '確認',
    changing: '變化',
    deleting: '刪除',
    reaming:
      '目前有兩個與您的帳戶關聯的電子郵件地址。您可以添加更多5電子郵件。',
    qa_1: '什麼是第一次參加學校的名字？',
    qa_2: '什麼是第一只寵物的名字是什麼？',
    edit_phone: '編輯現有的電話號碼',
    korea: '韓國',
    explanation:
      '添加了數字，我確認您同意自動撥打，接聽預錄電話和文本取決於原因機關將兩個數字相加的隱私政策進行說明。標準費率付費。',
    edit_phone_num: '變更電話號碼',
    edit_password: '更改密碼',
    confirm_password: '檢查您當前密碼',
    new_passod: '新密碼',
    confirm_password_new: '確認新密碼',
    secure_question: '安全問題',
    secure_pick: '選擇題',
    secure_answer: '答案',
    edit_browse:
      '隨著ONEWORLDPAY一鍵就可以快速完成支付，而不必每次都要登錄時間英寸',
    already_log: '在登錄到計算機上。',
    off_all: 'ONEWORLDPAY一鍵關閉所有設備上的',
    support: 'PayPal致力於讓客戶100％滿意。如果您有您的帳戶有問題',
    support_center: '客戶支持',
    support_text1: '或檢查',
    support_text2: '請參考。',
    support_warn:
      '如果您取消帳戶，則無法取消您的帳戶記錄也將消失和可靠性水平。',
  },
  help: {
    support_center: '支持',
    resolution_center: '爭議解決中心',
    qa_search: '搜索常見問題解答',
    common_qa: '普通問題',
    common_qa_1: '什麼`為什麼通過“獲取鏈接基金更新您的訂單狀態後顯示錯誤消息？',
    common_qa_2: '如何從韓國ONEWORLDPAY賬戶中提取資金？',
    common_qa_3: '如何添加借記卡或信用卡帳戶ONEWORLDPAY？',
    common_qa_4: 'ONEWORLDPAY我忘記了帳戶密碼。如何重置密碼？',
    common_qa_5: '我能取消已經發出已支付金額ONEWORLDPAY？',
    common_qa_6: '我如何收到通過ONEWORLDPAY付款？',
    common_qa_7: '如何發送通過ONEWORLDPAY支付？',
    common_qa_8: '如何添加一個銀行賬戶ONEWORLDPAY帳戶？',
    common_qa_9: '如何檢查我的帳戶ONEWORLDPAY相關聯的銀行帳戶？',
    common_qa_10: '如何禁用帳戶ONEWORLDPAY限制？',
    technical_support: '訂閱技術問題和更新。',
    condition_cocopay: '查看ONEWORLDPAY狀態',
    muliple_help: '更多方式獲得幫助',
    trading_help: '為了解決這樣的問題處理',
    tex_center: '稅務中心',
    tex_help: '查找稅務表格和其他資源',
    need_help: '聯繫我們',
    help_center: '聯繫客戶支持',
    help_to_center: '聯繫客戶支持',
    prepare: '即將推出。',
    fast_help: '請告訴我們您的問題，使我們能更快地幫助ONEWORLDPAY。',
    my_search: '搜索我的問題',
    common_problem: '常見問題',
    login_problem: '登錄問題',
    unkown_charge: '未經授權的訪問或未知的申請報告',
    send_money: '匯款',
    get_fund: '收到錢',
    withdraw_money: '取錢',
    pay_cancel: '付款或取消訂單',
    pay_hold: '付款掛起或等待',
    refund: '退款',
    pre_pament: '預先核准付款',
    negative_balance: '負平衡',
    account_qa_1:
      '雖然它顯示為“已完成”從我的帳戶ONEWORLDPAY退出狀態，這是為什麼不包含銀行賬戶的錢？',
    account_qa_2: '什麼是我的提款ONEWORLDPAY的原因仍是“待定”狀態？',
    account_qa_3: '為什麼我撤回前？',
    item_title: '訪問密碼和帳戶',
    item_title_2: '帳戶資料＆設置',
  },
  business: {
    no_trade: '有沒有可能交易市場。',
    view_your_account: '查看您的整個帳戶',
    available: '可得到',
    calculate_late: '最近估計基於匯率金額。',
    payment_transfe: '支付轉賬',
    exchange: '貨幣交換',
    currency_update: '添加通話',
    update_btn: '加號按鈕',
    currency_cal: '貨幣換算',
    pay_default: '首付款',
    payment_send: '發送或請求付款',
    account_list: '帳戶列表',
    no_alias: '無別名',
    new_bank: '連接新銀行',
    card: '卡',
    new_card: '連接新卡',
    credit: '信用',
    preference_payment: '選擇您喜歡的在線支付方式。',
    payment_tip:
      '當網上購物或使用該手段商品和服務在付款。您可以在任何時候選擇在結帳時不同的付款方式。',
    payment_more: '了解您的支付偏好',
    paymnet_changes: 'ONEWORLDPAY平衡',
    debit_card: '轉賬卡',
    currency_tip:
      '如果添加的貨幣，該貨幣以後接收的所有款項將記入相應的資金。基礎貨幣被用來發送一個付款或付款請求。',
    currency_1: '澳大利亞元',
    currency_2: '瑞士法郎',
    currency_3: '捷克克朗',
    currency_4: '丹麥克朗',
    currency_5: '歐元',
    currency_6: '英鎊',
    currency_7: '港元',
    currency_8: '福林',
    currency_9: '以色列新謝克爾',
    currency_10: '墨西哥比索',
    currency_11: '挪威挪威克朗',
    currency_12: '紐元兌美元',
    currency_13: '菲律賓比索',
    currency_14: '波蘭茲羅提',
    currency_15: '俄羅斯盧布',
    currency_16: '瑞典克朗',
    currency_17: '新加坡元',
    currency_18: '銖',
    currency_19: '新台幣',
    withdraw_account: '撤回賬戶',
    exchanged: '貨幣兌換後',
    exchange_rate: '匯率',
    exchange_tip: '匯率是基於當前匯率的估計量，交換費包含在ONEWORLDPAY。',
    currency_default: '（A）的日元被設置為默認貨幣。',
    currency_default_notice: '基礎貨幣被用來發送一個付款或付款請求。',
    currency_default_notice2: '關閉通話的餘額，不顯示沒有收到任何付款的電話。',
    currency_default2: 'JPY（S），默認',
    currency_quit_jp_btn: '關閉美元',
    currency_quit_btn: '千鈞一發',
    bank_account: '帳號',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: '餘額',
    bank_account_check: '保兌行',
    bank_account_remove: '刪除銀行',
    bank_continue: '你想繼續嗎？',
    bank_tip: '與銀行待處理的交易被刪除後進行處理。',
    bank_this_delete: '刪除銀行',
    card_tip: '該ONEWORLDPAY帳戶要使用它無需花費或提款限額？',
    card_confirm: '檢查卡。',
    card_type: '類型',
    expiry_date: '到期日',
    card_adress: '帳單地址',
    card_update: '卡更新',
    card_delete: '刪除卡',
    card_this_delete: '刪除卡',
    card_tip2:
      '此付款方法目前優選的。完成後，您可以設置不同的首選付款方式。處理是與（a）中未決的未定義刪除後進行處理。',
    secure_code: '驗證碼',
  },
  shop: {
    shop_list: '商店列表',
    shop_create: '創建鋪',
    shop_cre_date: '額外',
    shop_title: '商店名',
    shop_id: '商店ID',
    shop_state: '狀態',
    shop_work: '工作',
    shop_detail: '更',
    shop_retouch: '水晶',
    shop_settlement: '結算清單',
    no_shop_history: '沒有交易記錄。',
    shop_history: '交易記錄',
    no_shop_list: '沒有店鋪一覽',
  },
  merchant: {
    create: '網店註冊',
    update: '登錄',
    retouch: '商店修改',
  },
  pay_legal: {
    service_usage: 'ONEWORLDPAY服務條款',
    detail_usage:
      '這些條款和條件將適用於亞太地區，拉丁美洲和歐洲的一些國家，中東和非洲用戶。要查看條款和不同國家或地區的條件下，從下面的列表中進行選擇。',
    nation: '選擇一個國家',
    every_consumer: '所有用戶',
    service_agree: '您的服務合同ONEWORLDPAY',
    privacy_state: '隱私政策',
    purpose_policy: 'ONEWORLDPAY使用政策',
    payment_agreement: 'ONEWORLDPAY其他方式付款協議',
    sell_buy: '商家和企業',
    shop_policy: 'ONEWORLDPAY支持存儲策略',
    contract_profit: '合同以營利為目的的公司',
    billing_agreement: '結算協議',
    direct_debit_agreement: '收到ONEWORLDPAY資金和借記協議',
    additional_info: '更多信息',
    infringement: 'Somyeongseo違反政策',
    policy_update: '政策更新',
    warn1:
      '通知消費者：ONEWORLDPAY支付服務被看作是按照澳大利亞法律支付（儲值工具）的預付費方式。',
    warn2:
      'ONEWORLDPAY支付的預付方式的業主ⓒCocofx私人有限公司不需要澳大利亞金融監管局的批准。我們也鼓勵消費者（用戶）仔細閱讀這些條款和條件。',
    warn3: '本使用條款和通告的規定的條款和與特定ONEWORLDPAY服務相關的條件。',
  },
  pay_privacy: {
    effective_day: '生效日期：2019 3月28日',
    summary: '摘要',
    personal_data: '通過ONEWORLDPAY收集的個人數據',
    personal_date_cause: '理由保持您的個人資料ONEWORLDPAY',
    summary_1: '我們的用戶',
    summary_2: '網站',
    summary_3: '或訪問',
    summary_4: '服務',
    summary_5: '當使用用戶',
    summary_6: '個人資料',
    summary_7:
      '如何收集和存儲，管理和共享，解釋傳輸已經編寫了本隱私政策。訪問我們的網站或使用該服務時，該隱私政策適用於您的個人資料，其他ONEWORLDPAY',
    summary_8: '用戶',
    summary_9:
      '它並不適用於網站或不擁有在線web ONEWORLDPAY或調整，包括服務站點或服務。',
    summary2_1:
      'ONEWORLDPAY您可以訪問我們的網站或當您使用以下類型的服務收集個人信息。',
    summary2_2: '使用向上和信息',
    summary2_3:
      '當您註冊一個帳號使用ONEWORLDPAY的服務，以滿足必要的信息，以提供用戶所請求的服務來收集個人數據。',
    summary2_4:
      '根據所選擇的服務，您可以要求提供創建用戶名所需的標識信息，郵寄地址，電話號碼，電子郵件地址，帳號。',
    summary2_5: '條款你可能會問，以提供額外的個人資料，這取決於服務。',
    summary3_1: '交易經驗和信息',
    summary3_2:
      '使用ONEWORLDPAY，或者如果訪問該網站，例如服務，從賣方購買，或收到錢，或者如果處理支付或匯款給朋友和家人，收集其他交易相關的信息，以及來自ONEWORLDPAY交易信息的。其他與貿易相關的信息，包括發送或請求金錢，物品或金錢支付服務的賣家，包括有關的所有信息來完成交易的信息和設備信息的支付方式，技術數據，位置信息等。',
    summary4_1: '參與者信息',
    summary4_2:
      '當您使用或訪問網站ONEWORLDPAY服務收集的個人數據用戶提供有關參與交易的其他參與者。',
    summary4_3: '要發送或請求的錢',
    summary4_4:
      '如果您發送或請求資金通過服務ONEWORLDPAY收集您的姓名，郵寄地址，電話號碼，個人數據，如從參與者發送的錢給你的你的財務賬戶信息收錢。',
    summary4_5:
      '有關要求參與者的個人數據的範圍可能取決於用於發送或要求金錢服務。',
    summary5_1: '付款方式為其他人而不是票據或票據要求付款給其他人',
    summary5_2:
      '如果使用ONEWORLDPAY服務，讓他們付賬代他人的，或者代表他們支付賬單給其他用戶，用戶名，郵件地址，電話號碼，電子郵件地址，用戶計費，而不是賬單或他人的帳戶擁有者必須收集相關的個人資料，包括你想，而不是支付賬號。',
    summary6_1: '錢添加到您的帳戶',
    summary6_1_1: '您的帳戶',
    summary6_2:
      '為了加錢到其他帳戶的用戶帳戶或用戶可以擁有，或者如果您使用ONEWORLDPAY服務請求被加入到量在此帳戶對其他用戶的另一邊從用戶有效地處理您的請求收集信息或可以從對方收集您的信息。',
    summary6_3:
      '例如，充電或使用服務ONEWORLDPAY請求，以添加到帳戶的手機數量，你可以收集其他信息，包括個人資料，以及其他參與者的移動賬戶號碼。',
    summary7_1: '與您的朋友和聯繫人人信息',
    summary7_2:
      '當用戶在您的帳戶連接的聯繫人列表，很容易給幫助人們處理當您的朋友和聯繫人ONEWORLDPAY。這樣用戶可以使用該設備，或者建立社會媒體平台或設備ONEWORLDPAY賬戶或社交媒體之間的連接時連接到該平台更好ONEWORLDPAY服務收集和ONEWORLDPAY使用您的聯繫人列表中的信息（姓名，地址，電子郵件地址等）改善環境。',
    summary8_1: '您選擇的信息，以提供ONEWORLDPAY才能使用某些在線服務或額外服務',
    summary8_2:
      '如果請求或參加現場要求的功能或改進服務，或其他可選功能的選擇，你可以收集有關ONEWORLDPAY用戶的其他信息。',
    summary8_3:
      '如果從這些服務中用來收集信息的方法，由本隱私權政策聲明不同，另行通知期間收集的信息。',
    summary9_1: '使用“ONEWORLDPAY不付款”的服務，當用戶信息',
    summary9_2:
      '對於一些有限的服務，可能需要登錄或使用您的帳戶設置不付款。 ONEWORLDPAY將收集，所有的支付方式相關的設備信息，技術數據，位置信息需要用戶完成交易的個人資料。當您選擇帳戶所有者和非貿易支付，你可以建立並與您的帳戶關聯收集交易信息。',
    summary9_3:
      '如果用戶在不帳戶擁有者，並選擇非ONEWORLDPAY交易付款，收集和存儲您提供的所有信息的使用和依照本隱私政策的信息共享。',
    summary10_1: '從第三方獲得用戶的具體信息',
    summary10_2:
      '從第三方（如商家），數據提供者，徵信機構允許的範圍內通過法律，你可以得到的信息。',
  },
  partner: {
    be_partner: '成為ONEWORLDPAY的合作夥伴。',
    banner_text:
      '購物平台提供商，市場，還有一個計費支持運營商需要支付服務提供商可以ONEWORLDPAY的合作夥伴。',
    banner_btn: '要聯繫您的客戶經理',
    benefit: '合作夥伴有權ONEWORLDPAY好處',
    benefit_1: '整合與建設解決方案技術支持',
    benefit_2:
      '請隨時聯繫我們的支持團隊為您獲得ONEWORLDPAY集成的幫助。 ONEWORLDPAY開發者門戶還可以用來作為一種資源。',
    benefit_3: '通過營銷機會的業務增長',
    benefit_4: '以提供ONEWORLDPAY可以吸引潛在客戶的許多市場機會。',
    traction: '和牽引世界各地的付款。',
    traction1:
      'ONEWORLDPAY合作夥伴支持的創新平台，為順利解決賣家的信任ONEWORLDPAY。',
    traction_btn: '更多的合作夥伴',
    program: 'ONEWORLDPAY合作夥伴計劃是免費加入。',
    program_1: '請填寫在線表格，我們將在ONEWORLDPAY與您聯繫。',
    program_2: '請介紹業務和運行的業務解決方案。',
    program_3: '請聯繫ONEWORLDPAY討論必要的修改。',
    program_4: 'ONEWORLDPAY整合與和幫助​​確保他們收到付款ONEWORLDPAY。',
    program_btn: '要聯繫您的客戶經理',
    common_qa: '常問問題',
    common_qa1: '是否有任何廠商ONEWORLDPAY合作夥伴？',
    common_qa1_text:
      'ONEWORLDPAY合作夥伴是B2B（企業對企業）公司，為客戶提供解決方案ONEWORLDPAY。 ONEWORLDPAY正與組織，如購物車，網絡託管公司，Web開發人員，物流提供商和數字營銷公司，支付網關。',
    common_qa2: '什麼ONEWORLDPAY合作夥伴資格？',
    common_qa2_text: '請聯繫您的客戶經理',
    common_qa2_text_2: '您可以對合作夥伴的資格獲得建議。',
    common_qa3: '我們提供的ONEWORLDPAY集成支持服務？',
    common_qa3_text:
      '一旦合作夥伴計劃和ONEWORLDPAY批准加入註冊，您可以訪問有價值的集成文檔和開發者論壇。它也可以讓顧問證書集成支持。',
    common_qa4:
      '還有韓國的公司之外，我可以單獨報名參加合作夥伴計劃的每一個國家？',
    common_qa4_text:
      '這取決於您所在的國家經營業務。在ONEWORLDPAY正在部署專門的合作夥伴代表，在不同國家地區的要求。',
    common_qa4_more: '查看合作夥伴計劃提供國家',
  },
  pay_main: {
    total_product: '總產品',
    total_sum: '骨料',
    pay_this_account: '設置此帳戶作為付款方式。',
    bill_show: '此交易內容清單如下',
    banner_text: 'ONEWORLDPAY更安全',
    banner_text2: '快速付款。',
    banner_text3: '無論在哪裡購物，將讓您的金融信息安全。',
    footer_1: '條款和條件',
    footer_2: '用戶協議',
    footer_3: '隱私政策',
    footer_4: '反饋',
    footer_5:
      '消費者的通知：Coco Bank個人資料預付款的所有者ⓒCocobank保留所有權利不需要批准瑞典金融監管機構。',
    footer_6: '使用條款',
    footer_7: '我們也鼓勵您仔細閱讀。',
    footer_8: '結算',
    wallet: '電子錢包管理',
    last_name: '性別',
    card_number: '卡號',
    three_number: '三位數字',
    name: '名',
    pay_cocopay: '通過ONEWORLDPAY支付',
    free_shipping: '如果ONEWORLDPAY帳戶，你可以得到免費的退貨運費，購買保護。',
    email_phone: '電子郵件或電話號碼',
    login_error: '你有麻煩了簽約？',
    pay_card: '付款卡',
    cancel_back: '取消並返回到前一頁',
  },
  site_map: {
    site_map_tip: '一個鏈接，這將幫助你探索ONEWORLDPAY帳戶。',
    map_fund: '資金',
    map_fund_1: '扣除',
    map_fund_2: '我使用的平衡能力是什麼？',
    map_fund_3: '匯款或要求付款',
    map_fund_4: '呼叫管理',
    map_fund_5: 'ONEWORLDPAY我的借記卡折扣',
    map_fund_6: '獲取ONEWORLDPAY借記卡',
    map_fund_7: 'ONEWORLDPAY信貸結算時間表',
    map_deal: '合同',
    map_deal_1: '查看所有優惠活動',
    map_deal_2: '活動的意見（包括資產和費用）',
    map_deal_3: '查看特價圖形和圖表',
    map_deal_4: '下載新政',
    map_deal_5: '響應於根據權利要求或拒付',
    map_deal_6: 'IPN（即時付款通知）歷史',
    map_profile: '我的個人資料和設置',
    map_profile_1: '商業鏡',
    map_profile_2: '電子郵件，地址，電話或密碼更新',
    map_profile_3: '銀行賬戶或卡更新',
    map_profile_4: '更新通知',
    map_profile_5: '查看賬戶限額',
    map_profile_6: '用戶管理',
    map_profile_7: '送更新偏好',
    map_support: '支持',
    map_support_1: '轉至解決衝突中心',
    map_support_2: '去支持中心',
    map_support_3: '聯繫我們',
    map_support_4: 'ONEWORLDPAY商戶費用信息',
    map_report: '報告',
    map_report_1: '報告設置，管理或下載',
    map_manage: '工具',
    map_manage_1: '查看工具',
    map_manage_2: 'ONEWORLDPAY按鈕管理',
    map_manage_3: '定期支付管理',
    map_consum: '顧客',
    map_consum_1: '查看嘉賓名單',
  },
  fee: {
    fee_tip: '簡單的收費結構',
    fee_banner_1: '一般來說，購買是免費的，可能受到貨幣兌換費。',
    fee_banner_2:
      '如果銷售不堅持使用ONEWORLDPAY月租費，或者取消費用。每個委託後才會支付。',
    fee_h2: '通常購買的是免費的。',
    fee_text1: '用於處理支付費用是由賣方支付。',
    fee_text2: '但是，您可以兌換手續費應用。',
    fee_more: '賣家收費了解更多',
    fee_text3: '對於憑發票或付款電子郵件網站銷售（國際支付標準費率適用）',
    fee_text4: '根據收到呼叫的固定費用',
    fee_text5: '交易所費用可以另外申請。',
    fee_text6: '例如，對於一個固定費用付款收據以美元為$ 0.30美元。',
  },
  dash: {
    more: '查看更多',
    withdraw_asset: '基金撤離',
    currency: '貨幣',
    quotes: '發票和會計估計',
    last_6_months: '最近6個月',
    make_invoice: '發票代',
    manage_invoice: '發票管理',
    grown_up: '請把發展業務的報價。',
    un_paid_invocie: '未付發票',
    make_quotes: '報價代',
    quotes_1: '人提出任何未付發票。',
    quotes_2: 'ONEWORLDPAY發票',
    quotes_alarm: '發送提醒',
    quotes_detail: '顯示更多',
    quotes_who: '比爾：財，所以 - 楊',
    latest_act: '近期活動',
    act: '活動',
    received: '收到付款',
    send: '從付款方式',
    act_record: '活動（包括資產和費用）',
    pay_person: '比勒人',
    show_all: '查看所有',
    tell_us: '請告訴我們你的意見。',
    feed_text:
      '請花一點時間來告訴我們在這個頁面上全新設計的顯示信息，你的意見。謝謝！',
    service: '提供反饋',
    feed_text_back: '謝謝您的意見！這是我們的網站是如何有用嗎？',
    feed_placeholder:
      '請讓我知道我今天來有ONEWORLDPAY是一個更好的辦法的原因。不包括個人信息，如電子郵件或賬戶號碼。',
    feed_p:
      'ONEWORLDPAY辦公室工作人員和客人您的意見可以在內部發布，所以你可以看到它，不會留下任何個人信息。客戶服務問題，請點擊此處。 ONEWORLDPAY的',
    feed_protect: '隱私政策',
    feed_law: '法律條款',
    feed_or: '和',
    feed_need: '見',
    trade_name: '交易名稱',
    trade_id: '交易ID',
    transaction_type: '交易類型',
    trade_amount: '付款',
    detail_show: '看',
  },
  shop_detail: {
    detail_info: '店詳細',
    api_signature: '商店簽名密鑰',
    msg_shop_create: '這家商店已被註冊。',
    msg_shop_modify: '這家商店已定。',
  },
  merchant_account: {
    create_account: '生成結算賬戶',
    enroll_account: '登記結算帳戶',
    pls_select_account: '選擇結算賬戶',
  },
  transaction_detail: {
    select_pay_account: '請選擇支付賬戶',
    transaction_title: '交易細節',
    order_id: '車間定單號',
    pay_account_title: '付款賬戶名稱',
    pay_account_number: '支付賬號',
    pay_account_balance: '付款賬戶餘額',
  },
  guide: {
    title: 'C2C 交易指南',
    watch_video: '查看圖片',
  },
  account_transfer: {
    transfer: '轉賬',
    transfer_list: '轉賬記錄',
    msg_required_data: '請輸入所有的值',
    msg_not_select_withdraw_account: '請選擇取款賬號',
    create_transfer_title: '轉賬',
    from_account_select: '請選擇取款賬號',
    available_transfer: '可轉賬金額',
    to_account_input: '請輸入轉賬賬號',
    to_account_confirm: '轉賬賬戶確認',
    to_account_user_name: '轉賬賬戶會員名',
    transfer_amount: '轉賬金額',
    delete_amount: '更正',
    all_amount: '全額',
    description: '說明',
    transfer_btn: '轉賬',
    transfer_btn_2: '轉賬',
    transfer_info_check: '支票轉賬請求信息',
    transfer_info_check_2: '支票轉賬請求信息',
    from_account_number: '取款賬號',
    from_asset_title: '取款賬戶資產',
    to_account_number: '轉賬賬號',
    success_transfer: '轉讓已成功處理。',
    success_withdraw: '提款已成功處理。',
    transfer_list_detail: '傳輸歷史記錄＆',
    search_transfer_asset: '通過房產搜索',
    search_transfer_account: '請按賬戶搜索',
    reset: '初始化',
    search: '取回',
    transfer_list_detail_tit: '詳細轉賬記錄',
    no_transfer: '不得轉讓細節',
    msg_not_search_account: '帳號不存在或無效的輸入。',
    my_account_transfer: '我的賬戶轉賬',
    msg_pls_select_account: '選擇資產後，搜索帳戶。',
    placeholder_amount: '請輸入轉賬金額',
    not_search_user_name: '不知道用戶名',
    msg_select_asset_search: '請選擇一個帳號',
    success_fail: '傳送失敗。',
    pls_search_asset: '請搜索資產',
    pls_search_account: '請搜索賬戶',
    pls_select_asset: '請選擇一種資產。',
    select_account_first: '請先選擇一個帳戶。',
    select_market_first: '請先選擇市場',
    not_exist_account: '資產的帳戶不存在。',
    favorites: '收藏夾',
    no_inquiry_history: '沒有查詢記錄',
    from_user_name: '逾期賬戶的成員',
  },
  bank_service_center: {
    title: '主題',
    date: '日期',
    state: '狀態',
    enter_search_word: '輸入您的搜索字詞',
    list: '名單',
  },
  service_center: {
    view_all: '查看全部',
    contact_history: '查詢歷史',
    privacy_Statement: '個人信息處理政策',
    would_you_agree: '您要同意以上內容嗎？',
    mobile_number: '手機號碼',
    target_of_inquiry: '詢問對象',
    inquiry_contents: '諮詢內容',
    please_enter_your_inquiry: '請輸入您的詢問。',
    send: '發送',
    normal_inquiries_received: '您的詢問已成功收到。',
    inquiry_history: '查詢歷史',
    pls_select_inquiry_type: '請選擇接觸的類型',
    pls_login_to_use_inquiry: '1，登錄第一查詢。',
    non_member_login: '非會員登錄',
    contact_id: '聯繫ID',
    view_inquiry: '查看聯繫人',
    service_center: '客戶服務',
    inquiry_details: '聯繫方式',
    msg_enter_title: '請輸入標題。',
    msg_enter_your_content: '請輸入您的信息。',
    msg_pls_login: '請登錄。',
    go_back: '回去',
    re_contact: '觸點材料',
    contents: '內容',
    msg_no_inquiry_history: '沒有聯繫方式。',
    msg_require_login_additional_authentication: '您需要登錄或其他身份驗證。',
    when_you_member: '當一個成員',
    msg_inquiry_history_can_view_after_login:
      '的聯繫人詳細信息的成員可以在登錄後進行查看。',
    non_member: '當非會員',
    lookup_inquiry: '聯繫人查找',
    msg_enter_inquiry_id: '請輸入聯繫人ID。',
    msg_enter_password_when_registering_your_inquiry:
      '當你調用註冊請輸入你設置的密碼。',
    frequently_asked_questions: '常問問題',
    msg_enter_your_password: '請輸入您的密碼。',
  },
  modal: {
    not_seeing_day: '白天沒見',
  },
  login_guide_modal: {
    title: '說明',
    sub_title: '為了方便使用你的星座會導致系統改革的交流。',
    content:
      '[更改前]<br/>初次註冊時進行的登錄<br/><br/>[更改後]<br/>更改為當前的電話號碼或電子郵件登錄<br/> <br/>登錄直到重組系統。 ',
  },

  affiliate: {
    affiliate_occur_list: '津貼記錄',
    affiliate_adjust_list: '津貼結算明細',
    allowance_balance_asset: '資產備抵餘額',
    list_allowance_balance_asset: '按資產劃分的備抵餘額清單',
    search_by_asset: '請按資產搜索',
    allowance_search: '配額搜索',
    generator: '發電機',
    beneficiary: '受益人',
    benefactor: '恩人',
    behavior_type: '行為類型',
    target_unique_number: '目標唯一編號',
    date_of_occurrence: '發生日期',
    application_policy_name: '申請政策名稱',
    beneficiary_type: '受益人類型',
    benefactor_type: '恩人類型',
    target_amount: '目標金額',
    principal_amount: '本金',
    allowance: '額外工資',
    allowance_assets: '備抵資產',
    allowance_amount: '津貼額',
    affiliate_log: '津貼細目',
    allowance_settlement: '津貼結算',
    allowance_settlement_info: '津貼結算信息',
    name_asset_settled: '待結算資產名稱',
    balance_receive_payment: '待付餘額',
    select_account_settled: '選擇要結算的帳戶',
    no_affiliate_log: '沒有津貼。',
    no_affiliate_balance: '沒有按資產分類的備抵餘額清單。',
    no_affiliate_adjust: '沒有津貼支付歷史。',
    asset_name: '資產名稱',
    asset_code: '資產代碼',
    balance: '平衡',
    cumulative_amount: '累計量',
    please_select_account: '請選擇一個帳號。',
    calculate: '計算',
    settle: '解決',
    calculate_amount: '結算金額',
    account_number: '賬號',
    registration_date: '登記日期',
    number: '數',
  },
  Coin_name: '幣種',
  main_function: '主功能',
  disclosure_ing: '在...的過程中',
  market_balance_transfer: '市場餘額移動',
  available_after_login: '登錄後即可使用。',
  fast_stable_deal: '一起快速穩定的交易',
  cryptocurrency_exchange: '加密貨幣交易所',
  go_transaction: '馬上交易',
  create_an_account: '創建帳戶',
  more_than_that: '那以上的價值',
  vision_title: '基於信任的規劃',
  vision_text1: 'ONEWORLDPAY在新的數字資產生態系統中提供將區塊鏈技術整',
  vision_text2: '合到現有支付網路的一站式解決方案。',
  fee_title: '手續費優惠',
  fee_text1: '免除創建賬戶手續費和賬戶維護費用',
  fee_text2: '免除購買/出售手續費。',
  row_title: '低門檻',
  row_text1: '比特幣、以太坊等多種虛擬貨幣，',
  row_text2: '低門檻，可以千元交易',
  easy_title: '便利的界面',
  easy_text1: '初學者也可以輕鬆交易。',
  easy_text2: '',
  full_time: 'Full Time交易',
  full_time_text1: '無論何時何地只要有手機和電腦，',
  full_time_text2: '一年365天24小時都可以交易。',
  easy_sellbuy: '隨時隨地的便捷交易',
  so_easy: '輕鬆舒適',
  b2c_mobile: 'B2C移動應用',
  app_sellbuy: '通過應用程序移動設備交易的話，',
  anywhere_use: '無論何時何地都可以和B2C一起進行交易。',
  now_start_buy: '馬上交易',

  procedure:
    '在ONEWORLDPAY.COM/COCOBNK.COM登陸時，對進行信息共享的批准過程，是SNS登錄（社交登錄）的必要步驟。如果未執行SNS的登錄過程，則無法登錄到ONEWORLDPAY / COCOBNK，該過程是根據《信息通信網路法》和《個人信息保護法》執行的。',
  snslink: '關於SNS帳戶關聯狀態下登錄的信息通信網路法是',
  four_one:
    '第四條 ①科學技術通信部長官 <br> 通廣播通信委員會通過促進信息通信網路的使用及穩定的管理和用戶保護等（以下稱「信息通信網路的促進以及信息保護等」），為建立信息社會奠定製定措施。',
  four_two: '②第1款規定的政策包括以下內容.  ',
  eight: '8 信息通信網路的安全性和可靠性',
  nine: '9.此外，促進信息通信網路的使用以及信息保護等需要的事項',
  execution: '正在按照該條款執行',
  privacy: '另外，個人信息保護法',
  twentyfour_three:
    '第二十四條（限制固有識別信息處理）③當個人信息控制者按照第一款的每個分段處理固有識別信息時，根據總統令規定其固有識別信息不會丟失、盜取、泄露、偽造、變造、損壞，因此要採取加密等確保安全性必要措施。',
  twentyfour_two:
    '第24-2條(限制居民身份證號碼處理）②個人信息管理者儘管有第24條第3款,也必須通過加密措施來確保其居民身份證號碼不被丟失，被盜，泄漏，偽造，更改或損壞的安全。在這種情況下，有關加密適用對象和各適用對象時期的必要事項是根據總統令考慮個人信息的處理規<br>模和泄漏的影響來決定。',
  implemented: '正在按照該條款執行',
  we_future: '我們的未來',
  pop_cocobank: '可可銀行',
  fourth_industry: '第四產業的領導者',
  oc_15: '十月15',
  officially_open: '正式開放！',
  head_branch_office: '韓國總公司（蠶室店）/第一分店（新沙店）',
  sep_15: '9月15日下午5點',
  open_popup: '打開',
  thanks_for: '謝謝您的鼓勵。',

  kiosk: {
    make_pay: '結算',
    product_name: '商品名',
    amount_payment: '結算金額',
    may_pay_guide_txt:
      '請將 <span style="font-weight:900; color:#2369b0;">ONEWORLDPAY {os}的結算二維碼</span> 掃描到終端即可完成結算。',
    app_download_btn: '請安裝 ONEWORLDPAY Android',
    app_download_qr_scan: '請掃描二維碼下載app。',
    app_install_txt:
      '請掃描下面的二維碼安裝 <span style="font-weight: 900; color: #1f67af">ONEWORLDPAY {os}</span>。',
    app_install_sub_txt:
      '請將ONEWORLDPAY 結算頁面二維碼掃描到終端即可進行結算。',
    app_install_sub_txt2: '會在以後提供ONEWORLDPAY ios服務。',
    direct_exchange_txt:
      '<span>將</span><strong>{asset1}</strong><strong>兌換</strong><span>成</span><strong>{asset2}</strong>',
    bank_use: '使用BANK',
    cocobank: 'ONEWORLDPAY',
    cocobank_account_transfer: '轉賬',
    store_use: '命令',
    location_store: 'co.u co.u',
    home_ad_1: '世界上第一個硬幣公開市場',
    home_ad_2: 'COCO MARKET',
    use: '使用方法',
    bank_direct_ex: '我馬上換錢',
    deposit_inquiry: '查詢',
    deposit_inquiry_txt: '查詢ONEWORLDPAY 賬戶',
    deposit_withdrawal: '取款',
    deposit_withdrawal_txt: '申請後，需要10秒~10分鐘左右',
    deposit_transfer: '錢包轉賬',
    deposit_transfer_txt: '其他交易所錢包轉賬',
    wallet_transfer: '錢包轉賬',
    wallet_transfer_txt: '轉移到另一個 交易所的錢包',
    exchange_list: '兌換記錄',
    certified: '認證管理',
    certified_drawer_title: '認證管理',
    direct_transaction: '直接交易',
    direct_transaction_txt: '立即兌換',
    c2c_transaction: 'C2C交易',
    c2c_transaction_txt: '客戶之間進行加密貨幣交易',
    account_application: '申請賬戶',
    account_application_txt: '申請賬戶',
    terms_title1: '有關限制限額的信息，以防止損害電信財務欺詐',
    terms_text1:
      '由於非面對面的帳戶開設，通過自動設備和互聯網進行的提款（轉賬）限制為每天0 CCF。<br />可以向分支機構提供用於確認交易目的的客觀身份驗證數據，並且可以在「管理>安全身份驗證/管理」中取消限制。<br />使用網上銀行時，必須註冊一個提款帳戶才能進行轉賬交易。<br />每個加密貨幣限制只能開設5個帳戶。',
    terms_notice1: '注意',
    terms_notice1_txt:
      '- 註冊網上銀行可以在開立存取款賬戶後，在完成畫面上聯動申請。<br />- 現有的網上銀行註冊客戶，請注意，只有在取款賬戶登陸區分為互聯網+分行時，才能通過網上銀行登錄取款賬戶。',
    terms_notice2:
      '※先進行安全認證的話，需要建立賬戶，使用網上銀行時登錄到取款賬戶才能進行轉賬交易。',
    cancel: '取消',
    security_authentication: '安全認證',
    new_registration: '註冊',
    terms_title2:
      ' 點擊註冊後，將發放會員固有的ONEWORLDPAY {0}專用賬戶及外部錢包聯動匯款地址。',
    terms_notice3: '匯款前一定要確認！',
    terms_notice3_text1:
      '只有註冊時發行的賬戶/地址才能進行{0}匯款。如果試圖將其他數字資產存入該地址，可能發生的錯誤/損失將無法恢復。',
    terms_notice3_text2:
      '確認後，通過匯款流程反映到餘額中。匯款過程將自動進行，根據網路情況所需時間可能會有所不同。',
    terms_notice3_text3: '上述地址是匯款專用地址。',
    terms_checkbox_text: '您是否同意並理解以上內容？',
    assets: '資產',
    favorite: '收藏夾',
    select_assets_txt: '請選擇一種資產。',
    search_assets: '搜索資產',
    search_assets_txt: '請搜索資產。',
    account_name: '用戶名',
    account_name_txt: '請輸入您的帳號',
    selected_assets: '可選資產',
    account_unique_number: '帳戶唯一編號',
    account_number: '賬號',
    stop_amount: '止損金額',
    state: '州',
    auto_input: '自動輸入',
    opening: '開了',
    application_success_txt: '帳戶申請已完成。',
    application_fail_text: '帳戶申請失敗。',
    confirm: '確認asd',
    previous: '以前',
    enter_account_number: '請輸入賬號',
    service_preparation: '服務準備中',
    service_preparation_txt1: '為了提供更好的服務，頁面正在準備中。',
    service_preparation_txt2: '會儘快安排時間拜訪您。',
    search_account: '搜索賬戶',
    search_account_txt: '請搜索賬戶',
    select_account_txt: '請選擇賬戶。',
    withdrawable_amount: '可取金額',
    inquiry_period: '查詢時間',
    variable_amount: '變動金額',
    no_deposit_history: '沒有查詢存款記錄',
    select_date: '請選擇日期',
    type_of_change: '變動類型',
    sort_order: '排序順序',
    inquiry_option: '查詢選項',
    select_market: '請選擇市場',
    reduction_rate: '手續費率',
    sales_quantity: '銷售數量',
    minimum_purchase_quantity: '最少購買數量',
    selling_price_per_piece: '單個銷售價格',
    account_for_registration_of_sales: '銷售登記用賬戶',
    purchase_assets: '購買資產',
    available_quantity: '可用數量',
    purchase_quantity: '購買數量',
    price_per_piece: '單價',
    quantity_to_be_paid: '要支付的數量',
    select_account_to_receive: '選擇要收款的賬戶',
    registration_was_successful: '登錄成功',
    registration_failed: '登錄失敗。',
    go_to_first: '回到首頁',
    purchase_history: '購買明細',
    purchase_price: '購買價格',
    no_description: '沒有明細。',
    sales_history: '銷售明細',
    price_per_quantity: '按數量計價',
    total_fee: '手續費合計',
    no_disclosure_details: '沒有公示內容',
    advanced_search: '詳細搜索',
    sales_registration: '出售登記',
    purchase_registration: '購買登記',
    verification_completed: '認證完了',
    email_authentication: '電子郵件認證',
    authenticate: '認證',
    identity_verification: '本人認證',
    otp_authentication: 'OTP認證',
    withdrawal_address_verification: '取款地址驗證',
    withdrawal_address_application_details: '取款地址申請記錄',
    no_withdrawal_address_application_details: '沒有取款地址申請記錄',
    kyc_authentication: 'KYC 認證',
    kyc_application_details: 'KYC 認證記錄',
    security_level: '安全等級',
    view_rating: '查看等級',
    no_account_alias: '（沒有賬戶名稱）',
    no_choice: '（沒有選擇）',
    select_coin_to_exchange: '請選擇想要兌換的硬幣',
    sending_verification_email: '請點擊發送認證郵件。',
    sending_verification_email_txt: '인증메일 발송하기를 눌러주세요.',
    enter_verification_code: '認證',
    enter_verification_code_txt: '請輸入驗證碼',
    verification_email_has_been_sent: '已發送認證郵件',
    base_asset_account_information: '基準資產賬戶信息',
    classification_of_transactions: '交易區分',
    logged_out_txt: '註銷了',
    check_logged_out_txt: '你要登出嗎',
    scan_qr_code_txt: '請掃描下面的二維碼',
    simple_login: '簡單登錄',
    simple_login_txt: '請輸入簡單登錄驗證碼',
    be_loggin_in: '登錄中',
    be_logged_in: '登錄了',
    step_one: '一階段',
    step_one_txt: '為了認證OTP，請在App Store安裝Google OTP。',
    step_two: '二階段',
    step_two_txt:
      '請列印或記錄已發行的16位代碼。本代碼用於修復手機上的丟失/更換及刪除。',
    step_three: '三階段',
    step_three_txt: '通過安裝的Google Authenticaror應用程序掃描下面的二維碼。',
    step_four: '四階段',
    step_four_txt: '輸入生成的OTP 6位數字驗證碼後點擊認證。',
    mobile_authentication: '手機認證',
    mobile_authentication_txt: '利用本人名義的手機進行認證。',
    do_mobile_authentication: '手機認證',
    complete_mobile_authentication: '認證完成了',
    failed_mobile_authentication: '認證失敗了',
    transfer_quantity: '轉賬數量',
    enter_transfer_quantity: '請輸入轉賬數量。',
    transfer_quantity_2: '轉賬數量',
    enter_transfer_quantity_2: '請輸入轉賬數量。',
    select_transfer_quantity: '請選擇轉賬數量。',
    enter_transfer_account_number: '請輸入轉賬賬號',
    current_security_level: '會員現在的安全等級',
    choose_how_to_pay_the_fee: '請選擇手續費支付方法',
    confirm_withdrawal_application_information: '確認取款申請信息',
    enter_login_code_txt:
      '請閱讀下麵條形碼閱讀器中終端屏幕上顯示的用於簡單登錄驗證的QR碼，或在下面的字段中輸入簡單驗證碼。',
    direct_ex_manual: '如何使用直接貨幣兌換',
    deposit_transfer_manual: '如何使用存款匯款',
    deposit_inquiry_txt_manual: '如何使用存款查詢',
    deposit_withdrawal_manual: '如何使用存款提取',
    wallet_transfer_manual: '如何使用錢包傳輸',
    buy_with_coin_selected_account: '使用{code}從選定的帳戶購買',
    sell_with_coin_selected_account: '在所選帳戶上出售{code}。',
    receive_purchased_coin: '請選擇一個帳戶以接收購買的{code}。',
    receive_converted_coin: '請選擇一個帳戶以接收轉換後的{code}。',
    enter_account_holder: '請輸入帳戶持有人的姓名。',
    enter_account: '請輸入您的帳號。',
    enter_withdrawal: '請輸入提款金額。',
    transfer_to_another_wallet: '轉移到另一個錢包',
    invalid_login_code: '無效的登錄身份驗證代碼。',
    payment_canceled: '付款已被取消',
  },

  market_balance: {
    deposit_successful: '存款成功。',
    wthdrawal_successful: '提款成功。',
    deposit: '存放',
    withdrawal: '取出',
    select_account: '選擇帳號',
    assets: '資產',
    select_market: '市場選擇',
    quantity: '數量',
    confirm: '確認',
  },
  pop_notice: {
    notice_close: '關閉',
    notice_today: '今天沒看到',
  },
  private_notice: {
    msg_false_deal_title: '禁止虛假公示',
    msg_false_deal_content_1:
      '賣家必須充分持有要賣出的加密貨幣，然後進行交易。',
    msg_false_deal_content_2: '持續進行虛假公示時，服務會受到限制。',
    msg_deal_confirm_click_title: '點擊確定時的注意事項',
    msg_deal_confirm_click_content_1: '賣家必須在確認買家付款後點擊“確定”，',
    msg_deal_confirm_click_content_2:
      '對於賣家不小心造成的金錢損失，ONEWORLDPAY不會負法律責任。請務必確認買家是否付款。',
    msg_deal_confirm_not_click_title: '當沒有按下確認鍵',
    msg_deal_confirm_not_click_content_1:
      '賣家在確認買家支付與否後，點擊“確定”。',
    msg_deal_confirm_not_click_content_2:
      '如果沒有點擊“確定”，管理員會限制服務使用。',
    msg_c2c_title: 'C2C交易',
    msg_c2c_content_1: 'C2C交易是由賣家和買家的自由交易活動為基礎的。',
    msg_c2c_content_2: 'ONEWORLDPAY只提供賣家和買家方便安全交易的平台服務。',
    msg_c2c_content_3:
      '請注意，賣家和買家之間發生法律糾紛時ONEWORLDPAY只負責作為信託賬戶的責任。',
    msg_false_hold_title: '禁止持假',
    msg_false_hold_content_1: '買家必須在該C2C交易支付完畢後點擊“holding”。',
    msg_false_hold_content_2:
      '因虛假holding而發生的賣家和買家之間的紛爭不由ONEWORLDPAY負責。',
    msg_false_hold_content_3:
      '另外，持續進行虛假holding時，請注意服務使用將受到限制。',
    msg_false_hold_content_4:
      '支付完畢後無法確定時，請通過1對1諮詢跟管理員溝通。',
    msg_false_hold_content_5:
      '通過外部錢包進行C2C交易時，會收取手續費，如果C2C交易無法正常進行時，對該交易的解決可能會有不便。',
  },
  kiosk_re: {
    choice_lang: '언어선택',
    buy_immedi:
      'ONEWOLRDPAY를 이용하시면<br><span>즉시 구입</span>이 가능합니다.',
    new_acc: 'ONEWOLRDPAY 계좌만들기',
    join_txt:
      '외부지갑 및 계좌를 이용시에는 구매예약을 하여 판매자의 확인여부가 필요하나 ONEWOLRDPAY를 이용하시면 즉시 구입이 가능 하십니다. ONEWOLRDPAY내에 이동시 수수료를 받지 않으며 세상에서 가장 빠른 암호자산간 이동을 지원하고 있습니다.',
    main_order_txt: '신용카드/암호자산 매장내 구입',
    main_bank_txt: '암호자산 안전하게 보관 및 구입/판매',
    main_market_txt: '온라인 암호자산 오픈마켓',
    main_about: '어바웃코인',
    main_about_txt: '암호자산에 대한 전문뉴스',
    about_drw_txt_1:
      '빠르고 다양한 블록체인 소식을<br><span>coinabout</span>에서 받아보세요.',
    about_drw_txt_2:
      '코인어바웃은 블록체인과 핀테크에<br>대한 빠른 소식과 분석을 제공합니다.',
    about_drw_txt_3: 'QR 코드를 스캔하면 코인어바웃으로 연결됩니다.',
    market_drw_txt_1: '이제 <span>가상자산으로 쇼핑</span>하세요.',
    market_drw_txt_2:
      '저희 코코마켓은 국내 최초 가상자산으로<br>물건을 사고팔 수 있는 오픈마켓입니다.',
    market_drw_txt_3: 'QR 코드를 스캔하면 코코마켓으로 연결됩니다.',
    market_drw_txt_4:
      '코코마켓은 이후 많은 상품과  다양한 가상자산<br>결제 시스템을 구축할 예정입니다.',
    login_title: '아래 <span>QR 코드</span>를 스캔해주세요.',
    login_txt_1: '서비스 사용을 위한 사용자의 정보가 필요합니다.',
    login_txt_2:
      '단말 화면에 표시된 간편 로그인 인증 코드를 아래 입력란에 입력해주세요.',
    code_txt: '간단로그인<br> <span>인증코드</span>를 입력하세요.',
    new_acc_tit_1: '신규 계좌 생성',
    new_acc_tit_2: '신규 계좌 생성에 필요한 내용들을 확인해 주세요.',
    new_acc_txt_1: '전기통신 금융사기 피해예방을 위한 한도제한 안내',
    new_acc_txt_2:
      '* 인터넷뱅킹으로 이체거래를 보다 더 간편하게 진행하시려면 보안 인증을 거치셔야합니다. 인증 과정을 통하여 등급을 향상시킨 후 계좌생성 및 출금계좌등록을 진행하시기 바랍니다.',
    new_acc_txt_3:
      'ONEWOLRDPAY전용 계좌에서 계좌로 송금하면 수수료가 일체 없습니다. 신규가입시 발행되는 계좌/주소로는 {0} 만 입금 가능합니다. 해당 주소로 다른 디지털 자산을 입금 시도할 경우에 발생할 수 있는 오류/손실은 복구 불가능 합니다. 1번의 확인이 발생한 이후, 입금 프로세스를 거쳐 잔고에 반영됩니다. 입금 프로세스는 자동으로 진행되며 네트워크 상황에 따라 소요 시간이 달라 질 수 있습니다. 위 주소는 입금전용 주소입니다.',
    new_acc_txt_4:
      '회원님에게 할당된 신규가입으로는 {0} 을 입금할 수 있습니다.',
    new_acc_btn_agr: '동의 및 계좌 개설',
    new_acc_txt_5: '신규 계좌가 개설되었습니다.',
    new_acc_txt_6: '개설된 계좌로 ONEWOLRDPAY서비스를 이용가능합니다.',
    charge_tit_1: '{0}를 충전합니다.',
    charge_tit_2: '{0}충전에 사용될 자산을 선택해주세요.',
    charge_tit_3: '계좌 선택 및 충전에 사용될 자산 수량을 입력해 주세요.',
    charge_txt_1: '충전 기준율',
    charge_txt_2: '충전 유형',
    charge_txt_3: '기준 수량',
    charge_txt_4: '충전 총액',
    charge_txt_5: '충전하기',
    charge_txt_6: '충전이 완료되었습니다.',
    charge_txt_7: '3초 뒤에 메인화면으로 돌아갑니다.',
    complete: '선택완료',
    input_complete: '입력완료',
    quan_max: '최대',
    buy_reserv: '구매예약 체결',
    krw_dialog_tit: '입금후에 구매예약 체결 버튼을 클릭해 주세요.',
    krw_dialog_txt_1:
      '이전 구매예약 클릭시 지갑 및 계좌는 동결되며 구매자가 최종적으로 아래 지갑 및 계좌에 최종 지불 할 금액을 입금후에 구매예약 체결 버튼을 클릭하셔야만 판매자에게 알림이 가며 판매자가 구매확인 하는 순간 구입자의 지갑 및 계좌에 구매하신 자산이 입금 됩니다.',
    krw_dialog_txt_2:
      '* 입금이 3시간 안에 구매예약 체결이 되지 않으면 동결된 지갑 및 계좌가 사용가능 하게 됩니다. 단, 입금하고 1시간 에서 2시간 안에 입금이 되지 않으면 고객센터에 연락주시기 바랍니다.',
    krw_dialog_txt_3:
      '구매자는 예약만 하고 입금이 3회 이상 되지 않으면 아이디가 정지됩니다.',
  },
}
